export enum LogGcpLevel {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  ALERT = 'ALERT',
  EMERGENCY = 'EMERGENCY',
  DEBUG = 'DEBUG',
}
